var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPdf(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 22,
    height: 25,
    viewBox: "0 0 22 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:none;}.b{fill:#acacac;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-459 -489)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "a",
    width: 22,
    height: 25,
    transform: "translate(459 489)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(427.496 489)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M118.775,259.6c0-.66-.459-1.055-1.268-1.055a2.77,2.77,0,0,0-.671.064v2.12a2.516,2.516,0,0,0,.543.042C118.242,260.767,118.775,260.331,118.775,259.6Z",
    transform: "translate(-81.481 -246.871)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M257.091,259.019a3.38,3.38,0,0,0-.735.064v4.7a2.946,2.946,0,0,0,.565.032,2.226,2.226,0,0,0,2.429-2.514A2.059,2.059,0,0,0,257.091,259.019Z",
    transform: "translate(-214.695 -247.307)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M52.1,8.882h-.6V6a.42.42,0,0,0-.005-.054.478.478,0,0,0-.115-.315L46.6.167l0,0a.483.483,0,0,0-.1-.081L46.465.063a.5.5,0,0,0-.1-.04L46.343.014A.486.486,0,0,0,46.231,0H34.466a.975.975,0,0,0-.974.974V8.881h-.6A1.392,1.392,0,0,0,31.5,10.273v7.237A1.392,1.392,0,0,0,32.9,18.9h.6v4.954a.975.975,0,0,0,.974.974H50.532a.975.975,0,0,0,.974-.974V18.9h.6a1.392,1.392,0,0,0,1.392-1.392V10.273A1.392,1.392,0,0,0,52.1,8.882ZM34.466.974H45.744V5.956a.487.487,0,0,0,.487.487h4.3V8.882H34.466ZM46.419,13.931a3.685,3.685,0,0,1-1.209,2.945,5.216,5.216,0,0,1-3.354.938,14.292,14.292,0,0,1-1.866-.108V10.565a14.711,14.711,0,0,1,2.223-.151,4.681,4.681,0,0,1,2.977.777A3.217,3.217,0,0,1,46.419,13.931Zm-12.7,3.808V10.565a13.514,13.514,0,0,1,2.222-.151A3.486,3.486,0,0,1,38.166,11a2.124,2.124,0,0,1,.776,1.683,2.321,2.321,0,0,1-.668,1.726,3.37,3.37,0,0,1-2.363.766,4.116,4.116,0,0,1-.561-.033v2.6H33.722Zm16.811,5.854H34.466V18.9H50.532v4.691Zm1.411-11.776H49.149v1.661h2.611v1.338H49.149v2.923H47.5V10.468h4.444Z",
    transform: "translate(0)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPdf);
export default __webpack_public_path__ + "static/media/pdf.7741f5e0b81bafd6737ddf68bba92e5b.svg";
export { ForwardRef as ReactComponent };